import { Rating as MuiRating, RatingProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { RatingProps };

export const Rating: React.ComponentType<RatingProps> = styled(MuiRating)<RatingProps>(() => ({}));
